import React from 'react'
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import {fetchDummyProducts} from "../data/axiosData";

function AxiosTest() {
  const [rows, setRows] = useState([]);

  const fetchProducts = async ()=> {
    await fetchDummyProducts()
    .then((res)=>setRows( res ));
  }
  const columns = [
      { field: "title", headerName: "Title", width: 150 },
      { field: "brand", headerName: "Brand", width: 150 },
      { field: "category", headerName: "Categorey", width: 150 },
      { field: "description", headerName: "Description", width: 380 },
      { field: "price", headerName: "price", width: 150, editable: true },
      { field: "rating", headerName: "Rating", width: 150 },
      { field: "stock", headerName: "Stock", width: 150 },
  ];

  useEffect(() => {
    fetchProducts();
  }, []);

  console.log('products: ', rows);

  return (
      <div className="Container">
          <div className="Grid">
              <DataGrid
              rows={rows}
              columns={columns}
              components={{ Toolbar: GridToolbar }} 
              checkboxSelection={true}
              pageSize={25}
              rowsPerPageOptions={[5, 10, 20, 30]}
              pagination
              />
          </div>
      </div>
  );
}

export default AxiosTest;